<template>
  <div class="button">
    <div v-if="!saving" @click="saveClicked" class="petitBouton"><img src="/assets/icons/save.png" /> Enregistrer</div>
    <div v-if="saving" class="modifs">
      Modifications enregistrées !
    </div>
  </div>
</template>

<script>
export default {
  name: "SaveButton",

  data() {
    return {
      saving: false
    };
  },

  computed: {},

  methods: {
    saveClicked: function() {
      this.saving = true;
      setTimeout(() => {
        this.saving = false;
        this.$emit("save");
      }, 2000);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

.button {
  display: grid;
  align-items: center;
  align-content: center;
  height: 41px;
}
.modifs {
  color: green;
  font-weight: bold;
  font-style: italic;
}
</style>
